export default function MiniInfoButton({
    text = "نامشخص",
    color = "gray",
    size = "text-nowrap",
    extraClassName = "",
    backgroundColor = "",
    textColor = ""
}) {
    return (
        <div
            style={{ backgroundColor: backgroundColor, color: textColor }}
            className={`${size} w-fit px-2 bg-[${color}] text-white p-1 rounded-lg ${extraClassName}`}
        >
            {text}
        </div>
    );
}